import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';

import CompactLayout from 'src/layouts/compact';

import { rootRoute } from './root';

const HowToLoginPage = lazy(() => import('src/sections/how-to-login/how-to-login'));

export const howToLoginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'how-to-login',
  component: () => (
    <CompactLayout>
      <HowToLoginPage />
    </CompactLayout>
  ),
});
